const searchStrip = {
  hotels: "בתי מלון", // translated
  city: "עִיר", // translated
  checkIn: "קבלה", // translated
  checkOut: "לבדוק", // translated
  date: "תַאֲרִיך", // translated
  persons: "אנשים", // translated
  adults: "מבוגרים", // translated
  rooms: "חדרים", // translated
  editSearch: "ערוך חיפוש", // translated
  newSearch: "חיפוש חדש", // translated
  listView: "תצוגת רשימה", // translated
  mapView: "תצוגת מפה", // translated
};


export default searchStrip;
